import tokeys from 'tokeys';

export const DeliveryMethods = tokeys([
  'ToSavedAddress',
  'ToCompanyAddress',
  'ToOtherAddress',
  'ToPickupPoint'
]);
